$(document).ready(function() {
  // Simple variables for our elements
  var $megaMenuItems = $('.navigation__item--with-mega-menu');
  var $megaMenuBg = $('.desktop-mega-menu-bg');
  var menuTimeout;
  var lastScrollTop = 0; // Track last scroll position
  
  // Function to check if we're on a desktop screen
  function isDesktop() {
    return window.innerWidth >= 1084;
  }
  
  // Function to handle mouse enter on mega menu items
  function handleMouseEnter() {
    if (isDesktop()) {
      clearTimeout(menuTimeout);
      $megaMenuBg.stop(true, true).fadeIn(500);
    }
  }
  
  // Function to handle mouse leave
  function handleMouseLeave() {
    if (isDesktop()) {
      menuTimeout = setTimeout(function() {
        if (!$('.navigation__item--with-mega-menu:hover, .navigation__tier-2-container:hover').length) {
          $megaMenuBg.fadeOut(500);
        }
      }, 200);
    }
  }
  
  // New function to handle scroll events
  function handleScroll() {
    if (isDesktop() && $megaMenuBg.is(':visible')) {
      var st = $(window).scrollTop();
      
      // If scrolling down, hide the mega menu background
      if (st > lastScrollTop) {
        $megaMenuBg.fadeOut(300);
      }
      
      lastScrollTop = st;
    }
  }
  
  // Attach event handlers
  $megaMenuItems.on('mouseenter', handleMouseEnter);
  $megaMenuItems.on('mouseleave', handleMouseLeave);
  
  // Also track when mouse leaves the dropdown areas
  $(document).on('mouseleave', '.navigation__tier-2-container', handleMouseLeave);
  
  // Add scroll event handler
  $(window).on('scroll', handleScroll);
  
  // Handle window resize events
  $(window).on('resize', function() {
    // If we're below the desktop breakpoint, make sure the overlay is hidden
    if (!isDesktop() && $megaMenuBg.is(':visible')) {
      $megaMenuBg.hide();
    }
  });
});